import { render } from "./PersonalNotAuth.vue?vue&type=template&id=810d2290"
import script from "./PersonalNotAuth.vue?vue&type=script&lang=js"
export * from "./PersonalNotAuth.vue?vue&type=script&lang=js"

import exportComponent from "C:\\PHPStormServer\\s_hmel\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__